import React, { useEffect, useState } from 'react'
import { Link,  useRedirect } from 'react-admin'
import { Grid2, Box, Chip, Typography, LinearProgress } from '@mui/material'

import { supabaseClient } from '../../supabase'
import { CardWithIcon } from '../../Design/Cards'

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

const DashboardPubeurEvents = ({ isMobile }) => {
  const redirect = useRedirect()

  const [isLoading, setIsLoading] = useState(true)
  const [nextEventsPubeur, setNextEventsPubeur] = useState([])

  useEffect(() => {
    const fetchEventsTypesNames = async (events) => {
      const eventsTypesIds = events.map(event => event.type_id)

      const { data, error } = await supabaseClient
        .from('types')
        .select('id, name, color')
        .in('id', eventsTypesIds)

      if (error) {
        console.error('Error fetching events types names:', error)
        return
      }

      const eventsTypesMap = data.reduce((acc, type) => {
        acc[type.id] = { name: type.name, color: type.color }
        return acc
      }, {})

      setNextEventsPubeur(events.map(event => ({
        ...event,
        type_name: eventsTypesMap[event.type_id]?.name,
        type_color: eventsTypesMap[event.type_id]?.color,
      })))
    }

    const fetchNextEvents = async () => {
      const today = new Date().toISOString().split('T')[0] // Get today's date in YYYY-MM-DD format
    
      const { data, error } = await supabaseClient
        .from('events_view')
        .select('*')
        .gte('date', today)
        // .or(`date.gte.${today},missionStartAff.gte.${today},missionStartHidden.gte.${today}`)
        .order('date', { ascending: false })
        .limit(5)
    
      if (error) {
        console.error('Error fetching next events:', error)
        return
      }
    
      setNextEventsPubeur(data)
      fetchEventsTypesNames(data)
      setIsLoading(false)
    }    

    fetchNextEvents()
  }, [])

  return (
    <div style={{ width: isMobile ? '100%' : '33.33333%' }}>
      <CardWithIcon
        icon={CalendarMonthIcon}
        title="Missions lycée à venir"
        subtitle={ nextEventsPubeur.length > 0 ? nextEventsPubeur.length : undefined }
        to="/leads"
        color="#ccc"
      >
        { isLoading
          ? <Typography variant="body2" color="text.secondary">
              <LinearProgress />
            </Typography>
          : nextEventsPubeur?.length > 0
            ? nextEventsPubeur?.map(event => {
              let eventDate = new Date(event.date)
              const options = { year: 'numeric', month: 'long', day: 'numeric', TimeRanges: 'Europe/Paris' }
              eventDate = eventDate.toLocaleDateString('fr-FR', options)
              const timeStart = event.timeStart ? 'à '+ new Date(event.timeStart).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : null
              const fullDateStart = `Le ${eventDate} ${timeStart ?? ''}`

              const now = new Date().toISOString()
              const nowMinusOneDay = new Date(new Date().setDate(new Date().getDate() + 1)).toISOString()
              const isNotHidden = now >= event.missionStartHidden
              const isVisible = now >= event.missionStartAff
              const isFullyVisible = nowMinusOneDay >= event.date
            
              return (
                <Box
                  key={event.id}
                  sx={{
                    p: 2,
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    borderRadius: 3,
                    mt: 1,
                    minHeight: '40vh'
                  }}
                >
                  <Grid2 container spacing={2}>
                    <Grid2 size={6}>
                      <Chip label={event.type_name} sx={{ marginBottom: 1, borderRadius: '5px', backgroundColor: event.type_color ? `#${event.type_color}` : undefined }} />
                    </Grid2>

                    <Grid2 size={6} textAlign="right">
                      <Typography variant="caption" color="text.secondary">
                        <b>{fullDateStart}</b>
                      </Typography>
                    </Grid2>
                  </Grid2>
                  
                  { isFullyVisible && (
                    <>
                      <Typography variant="body2" color="text.secondary">
                        <Link to={`events/${event.id}`}>{event.name}</Link>
                      </Typography>

                      {event?.schools_names?.map((schoolName, index) => (
                        <Chip
                          key={`${event.id}_${schoolName}`}
                          label={schoolName}
                          variant="contained"
                          sx={{ mt: 2, p: 1, backgroundColor: '#c5dedd', color: '#222', '&:hover': { backgroundColor: '#c5dedd' } }}
                          icon={<OpenInNewIcon />}
                          onClick={(e) => {
                            e.stopPropagation()
                            redirect(`/schools/${event?.schools_ids[index]}`)  // Assuming schools_ids is also present
                          }}
                        />
                      ))}
                    </>
                  )}

                  { isVisible && !isFullyVisible && (
                    <Typography variant="body2" color="text.secondary">
                      <Link to={`events/${event.id}`}>{event.name}</Link>
                    </Typography>
                  )}

                  { isNotHidden && !isVisible && !isFullyVisible && (
                    <p>Cet évènement n'est pas encore disponible.</p>
                  )}
                </Box>
              )
            }) : (
              <Box sx={{ p: 2, minHeight: '40vh' }}>
                <Typography variant="body2" color="text.secondary">
                  Aucune mission à venir pour le moment.
                </Typography>
              </Box>
            )
        }
      </CardWithIcon>
    </div>
  )
}

export default React.memo(DashboardPubeurEvents)